import { inject, Injectable } from '@angular/core';
import { Data } from '@angular/router';
import { Observable, map, filter, EMPTY } from 'rxjs';
import { StoreRepositoryService } from 'src/app/pages/store/store-repository.service';

@Injectable({
  providedIn: null,
})
export class JackpotDisplayHelper {
  private storeService = inject(StoreRepositoryService);

  public getJackpotText(paymentPageData: string): Observable<string> {
    if (typeof paymentPageData !== 'string') return EMPTY;
    const regex = /\[count_nearest_draw_date=([^\[\]]*)\]/g;
    const match = regex.exec(paymentPageData);
    if (!match) return EMPTY;
    const productName = match[1];

    return this.storeService.storePageData$.pipe(
      filter(Boolean),
      map((data: Data[]) => {
        const product = data.find(
          (p) => p?.real_name?.toLowerCase() === productName.toLowerCase()
        );
        if (!product) return paymentPageData;

        const expirySeconds = product?.jackpot?.expiry_date?.seconds;
        if (typeof expirySeconds !== 'number') return paymentPageData;

        const diff = expirySeconds * 1000 - Date.now();
        const replacement = diff <= 0 ? 'expired' : (this.formatTime(diff) || '0s');
        return paymentPageData.replace(/\[count_nearest_draw_date=[^\]]*\]/g, replacement);
      })
    );
  }

  private formatTime(ms: number): string {
    const s = Math.floor((ms / 1000) % 60);
    const m = Math.floor((ms / (1000 * 60)) % 60);
    const h = Math.floor((ms / (1000 * 60 * 60)) % 24);
    const d = Math.floor(ms / (1000 * 60 * 60 * 24));
    if (d > 0) return `${d}d ${h}hrs ${m}m`;
    let r = '';
    if (h > 0) r += `${h}hrs `;
    if (m > 0) r += `${m}m `;
    if (s > 0) r += `${s}s`;
    return r.trim();
  }
}
